<template>
  <div class="modal-content">
    <button type="button" class="close" @click="$emit('closeModal')">
      <span aria-hidden="true"><svg v-svg symbol="x" size="0 0 17 17"></svg></span>
    </button>
    <h3>{{ $t("domain.settings") }}</h3>
    <span>{{ $t("domain.select_platfrom") }}</span>

    <custom-multiselect v-model="activePlatform" :fixedHeight="200" :allowEmpty="true" :list="platforms" :multiply="true">
      <template v-slot:block="props">
        <span>
          {{ props.value.name }}
        </span>
      </template>
      <template v-slot:list="props">
        <span>
          {{ props.value.name }}
        </span>
      </template>
    </custom-multiselect>
    <button class="btn btn-save w-fit" @click="save">
      {{ $t("save") }}
    </button>
  </div>
</template>

<script>
import ServiceSubAccs from "@/api/subaccsService";
export default {
  props: {
    domain: {
      type: Number,
    },
  },
  data: () => ({
    activePlatform: [],
    platforms: [],
  }),
  methods: {
    save() {
      const ids = this.activePlatform.map((el) => el.id);
      ServiceSubAccs.saveDomainSubAccs(this.domain, ids).then((res) => {
        if (res && res.status === 200) {
          this.$alert({
            type: "success",
            title: this.$t("save_successfully"),
          });
        } else {
          this.$alert({
            type: "error",
            title: res.message,
          });
        }
      });
    },
  },
  created() {
    ServiceSubAccs.getDomainSubAccs(this.domain).then((res) => {
      if (res && res.status === 200) {
        this.platforms = res.data.subaccs;
        this.activePlatform = this.platforms.filter((el) => el.enabled) || [];
      } else {
        this.$alert({
          type: "error",
          title: res.message,
        });
      }
    });
  },
};
</script>

<style scoped>
.modal-content {
  position: relative;
  padding: 20px 20px 80px;
  min-height: 350px;
}

.btn-save {
  position: absolute !important;
  bottom: 20px;
  left: 20px;
}

.w-fit {
  width: fit-content;
}
</style>
